/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-popover-tooltip',
  templateUrl: './popover-tooltip.component.html',
  styleUrls: ['./popover-tooltip.component.scss']
})
export class PopoverTooltipComponent {
  @Input() tooltip: string;
}
